import * as fetch from '../../../utils/action'
import { getTotalNumber } from '../totalMethod'
import { formatDate, creatDownload } from '@/utils/formUtils'
import {
  compare,
  getdayType,
  cycleChange,
  getDeliveryType
} from 'enumeration/lab-order.js'
import billDatas from '@/store/actions/datas/bill'
import { trustDeedList } from 'json/trust-deed'
import { getEnumeration } from 'enumeration'
import orderflowHelper from '@/config/order'
import { getPlateType } from '@/utils/plateType'

export default {
  getSampleList (ctx, data) {
    return fetch.getSampleList(data).then(res => {
      res.data.forEach(ele => {
        ele = billDatas.formatSampleDetail(ele)
      })
      return getTotalNumber(res)
    })
  },
  
}
